/**
 * Reading a hyphenated slug back into the words it was made from. This is
 * parsing, not formatting: the slug's structure is what carries the words.
 */
/** A hyphenated slug read back as Title Case words. */
export function titleCasedSlug(value: string): string {
  return value
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
